import { render, staticRenderFns } from "./AddComplementaryExamToPrenatalConsultation.vue?vue&type=template&id=7d021dfc&scoped=true"
import script from "./AddComplementaryExamToPrenatalConsultation.vue?vue&type=script&lang=js"
export * from "./AddComplementaryExamToPrenatalConsultation.vue?vue&type=script&lang=js"
import style0 from "./AddComplementaryExamToPrenatalConsultation.vue?vue&type=style&index=0&id=7d021dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d021dfc",
  null
  
)

export default component.exports